module.exports = __webpack_public_path__ + "static/media/Test15.6dc80acd.bmp";